import LinkIcon from '@/assets/icons/link.svg?react';
import { ProductBuildingBlock } from '@/gql/graphql';

interface Props {
  bb: ProductBuildingBlock;
}

export const InformationTab = ({ bb }: Props) => {
  return (
    <div className="flex flex-col w-full gap-y-2" data-testid="building-block-details-information-content">
      {bb.informations?.map((info) => (
        <div
          className="flex flex-row justify-between items-center border rounded border-other-stroke flex-1 p-4"
          key={info.id}
        >
          <p data-testid={`building-block-details-information-${info.id}-linkText`} className="typo-primary-500">
            {info.linkText}
          </p>
          <a
            href={info.link || ''}
            target="_blank"
            rel="noreferrer"
            className="typo-primary-400 text-other-link"
            data-testid={`building-block-details-information-${info.id}-link`}
          >
            <LinkIcon />
          </a>
        </div>
      ))}
    </div>
  );
};
